namespace RioERP.Shipping {
    export interface ShippingRulesRow {
        Id?: number;
        ShippingProviderId?: number;
        EPriority?: Web.Enums.ShippingPriority;
        EPaymentMode?: Web.Enums.PaymentMode;
        ShippingProviderShippingProviderName?: string;
        ShippingProviderDescription?: string;
        ShippingProviderBankName?: string;
        ShippingProviderBankAccountNo?: string;
        ShippingProviderBankIfscCode?: string;
        ShippingProviderTrackingUrl?: string;
        ShippingProviderEApiStatus?: number;
        ShippingProviderGstin?: string;
        ShippingProviderPan?: string;
        ShippingProviderGstCertificate?: string;
        ShippingProviderSecret?: string;
        ShippingProviderIsActive?: boolean;
        ShippingProviderInsertUserId?: number;
        ShippingProviderInsertDate?: string;
        ShippingProviderUpdateUserId?: number;
        ShippingProviderUpdateDate?: string;
        ShippingProviderVendorId?: number;
        ShippingProviderEShippingProviderType?: number;
        ShippingProviderIsDefault?: boolean;
    }

    export namespace ShippingRulesRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Shipping.ShippingRules';
        export const deletePermission = 'Shipping:ShippingManagement:Modify';
        export const insertPermission = 'Shipping:ShippingManagement:Modify';
        export const readPermission = 'Shipping:ShippingManagement:View';
        export const updatePermission = 'Shipping:ShippingManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            ShippingProviderId = "ShippingProviderId",
            EPriority = "EPriority",
            EPaymentMode = "EPaymentMode",
            ShippingProviderShippingProviderName = "ShippingProviderShippingProviderName",
            ShippingProviderDescription = "ShippingProviderDescription",
            ShippingProviderBankName = "ShippingProviderBankName",
            ShippingProviderBankAccountNo = "ShippingProviderBankAccountNo",
            ShippingProviderBankIfscCode = "ShippingProviderBankIfscCode",
            ShippingProviderTrackingUrl = "ShippingProviderTrackingUrl",
            ShippingProviderEApiStatus = "ShippingProviderEApiStatus",
            ShippingProviderGstin = "ShippingProviderGstin",
            ShippingProviderPan = "ShippingProviderPan",
            ShippingProviderGstCertificate = "ShippingProviderGstCertificate",
            ShippingProviderSecret = "ShippingProviderSecret",
            ShippingProviderIsActive = "ShippingProviderIsActive",
            ShippingProviderInsertUserId = "ShippingProviderInsertUserId",
            ShippingProviderInsertDate = "ShippingProviderInsertDate",
            ShippingProviderUpdateUserId = "ShippingProviderUpdateUserId",
            ShippingProviderUpdateDate = "ShippingProviderUpdateDate",
            ShippingProviderVendorId = "ShippingProviderVendorId",
            ShippingProviderEShippingProviderType = "ShippingProviderEShippingProviderType",
            ShippingProviderIsDefault = "ShippingProviderIsDefault"
        }
    }
}
